<template>
  <div class="error">
    <template v-if="typeof error === 'string'">{{ error }}</template>
    <template v-else-if="typeof error === 'object' && error.length">
      <p v-for="(item, index) in error" :key="index">{{ item }}</p>
    </template>
    <template v-else>
      Something went wrong, please try again
    </template>
  </div>
</template>

<script>
export default {
  name: "ErrorBlock",

  props: {
    error: {
      type: [String, Object],
      default: "Something went wrong, please try again",
    },
  },
};
</script>
